export type TermsTypes =
  | 'lgpd'
  | 'warranty'
  | 'permanence-declaration'
  | 'discharge'
  | 'signatureTerm'
  | 'supplied-parts'
  | 'responsability'
  | 'plate-seal-cut';

export enum FontJustification {
  LEFT = 'LEFT',
  RIGHT = 'RIGHT',
  CENTER = 'CENTER',
  JUSTIFY = 'JUSTIFY',
}

export const FontJustificationTranslation = {
  [FontJustification.LEFT]: 'Esquerda',
  [FontJustification.RIGHT]: 'Direita',
  [FontJustification.CENTER]: 'Centro',
  [FontJustification.JUSTIFY]: 'Justificar',
};

export enum FontSize {
  SMALL = 'SMALL',
  MEDIUM = 'MEDIUM',
  LARGE = 'LARGE',
}

export const FontSizeTranslation = {
  [FontSize.SMALL]: 'Pequena',
  [FontSize.MEDIUM]: 'Média',
  [FontSize.LARGE]: 'Grande',
};

export enum FontSpacing {
  SMALL = 'SMALL',
  MEDIUM = 'MEDIUM',
  LARGE = 'LARGE',
}

export const FontSpacingTranslation = {
  [FontSize.SMALL]: 'Pequeno',
  [FontSize.MEDIUM]: 'Médio',
  [FontSize.LARGE]: 'Grande',
};

export interface GenerateLgpdTermInterface {
  companyId: number;
  customerId?: number;
}

export interface generateTermsWorkorderInterface {
  complementId: number;
  term: TermsTypes;
  fontJustification?: FontJustification;
  fontSize?: FontSize;
  fontSpacing?: FontSpacing;
}
